const stringifyOptions = (optionsArray) => {
  if (!optionsArray || optionsArray.length === 0) {
    return "";
  }
  // Ordena pelo produto relacionado para a chave não depender da ordem de seleção.
  return JSON.stringify(
    [...optionsArray].sort(
      (a, b) => a.relatedProduct.id - b.relatedProduct.id,
    ),
  );
};

// O replace remove TODO espaço — inclusive de dentro da observação e do JSON.
// Carrinhos já salvos dependem desse formato para continuar deduplicando.
// Respostas das Perguntas entram no fim só quando existem: item sem pergunta
// mantém a chave de sempre, e "Ao ponto" nunca se funde com "Bem passado".
export const buildCartItemKey = (product) => {
  const answers = stringifyOptions(product.selectedObservations);
  return `
      ${product.id}-
      ${product.observation || ""}-
      ${stringifyOptions(product.selectedFlavors)}-
      ${stringifyOptions(product.selectedAdditionals)}-
      ${stringifyOptions(product.removedCompositions)}
      ${answers ? `-${answers}` : ""}
    `.replace(/\s/g, "");
};

export const addItemToCart = (prevItems, product) => {
  const productKey = buildCartItemKey(product);
  const existingItem = prevItems.find((item) => item.uniqueKey === productKey);

  if (existingItem) {
    const newCount = existingItem.count + product.quantity;
    return prevItems.map((item) =>
      item.uniqueKey === productKey
        ? { ...item, count: newCount, totalPrice: item.unitPrice * newCount }
        : item,
    );
  }

  return [
    ...prevItems,
    { ...product, count: product.quantity, uniqueKey: productKey },
  ];
};

export const incrementCartItem = (prevItems, uniqueKey) =>
  prevItems.map((item) =>
    item.uniqueKey === uniqueKey
      ? { ...item, count: item.count + 1, totalPrice: item.unitPrice * (item.count + 1) }
      : item,
  );

export const decrementCartItem = (prevItems, uniqueKey) => {
  const itemToRemove = prevItems.find((item) => item.uniqueKey === uniqueKey);
  if (itemToRemove.count > 1) {
    return prevItems.map((item) =>
      item.uniqueKey === uniqueKey
        ? { ...item, count: item.count - 1, totalPrice: item.unitPrice * (item.count - 1) }
        : item,
    );
  }
  return prevItems.filter((item) => item.uniqueKey !== uniqueKey);
};

export const calculateCartTotal = (cartItems) =>
  cartItems
    .reduce((total, item) => total + item.unitPrice * item.count, 0)
    .toFixed(2);

// Próximo passo ao sair da sacola: "closed" | "checkout" | "login".
// canScheduleClosed: loja fechada que aceita agendamento (core/scheduling).
export const resolveCheckoutStep = ({ isRestaurantOpen, isLoggedIn, canScheduleClosed = false }) => {
  if (!isRestaurantOpen && !canScheduleClosed) return "closed";
  return isLoggedIn ? "checkout" : "login";
};

export const STORE_CLOSED_MESSAGE = "A loja está fechada no momento. Tente novamente mais tarde.";

export const getCartStorageKey = (slug, isTableMode, tableNumber) =>
  `carrinho-${slug}${isTableMode ? `-mesa-${tableNumber}` : ""}`;

export const loadCart = (key) => {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : [];
  } catch {
    localStorage.removeItem(key);
    return [];
  }
};

export const saveCart = (key, cartItems) => {
  localStorage.setItem(key, JSON.stringify(cartItems));
};

export const getPixPaymentStorageKey = (slug) => `pixPayment-${slug}`;
